import App from 'app'
import { useEffect } from 'react'
import { GetUser, Me, SetToken, SetUser } from 'services/Session'

export function sessionCallback(props) {
	let user = GetUser()
	useEffect(() => {
		const setSession = async () => {
			const q = require('query-string').parse(props.location.search)
			const token = await SetToken(q?.token)
			const res = await Me(token?.access_token)
			user = await SetUser(res?.data)
			if (q?.action?? '' !=='reset-password') {
				props.history.push('/')
			} else {
				props.history.push('/profil')
			}
		}
		setSession()
	}, [])

	return (
		<App user={user}>
			<div className='p-10 text-center'>
				<svg className="w-8 h-8 text-blue-500 animate-spin" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
					<circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
					<path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
				</svg>
			</div>
		</App>
	)
}
